module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2025-03-23 at 3.57.49 PM (1).d516ac47.jpeg";